import React, { useEffect, useState } from 'react';
import { motion, useScroll } from 'framer-motion';
import Hero from './components/Hero';
import About from './components/About';
import FeaturedEpisode from './components/FeaturedEpisode';
import ListenAnywhere from './components/ListenAnywhere';
import WhyDifferent from './components/WhyDifferent';
import SponsorCTA from './components/SponsorCTA';
import Contact from './components/Contact';
import './App.css';

function App() {
  const { scrollYProgress } = useScroll();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);

    // ESC key to close modal
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        document.body.style.overflow = 'unset';
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, []);

  if (!mounted) return null;

  return (
    <div className="app">
      <Hero />
      <About />
      <FeaturedEpisode />
      <ListenAnywhere />
      <WhyDifferent />
      <SponsorCTA />
      <Contact />
    </div>
  );
}

export default App;